import * as z from 'zod';

import type { CreateSchemaTypes } from '../createZodSchema';

export function phoneValidator(field: CreateSchemaTypes) {
  const baseValidator = field.required
    ? z.string().trim().min(1, 'Dit veld is verplicht')
    : z.string().trim();

  const validator = z
    .string()
    // Remove whitespace
    .transform((value) => (value ? value.replace(/\s+/g, '') : value))
    .refine((value) => {
      if (!value) return true; // Handle optional case
      // Check if starts with +, 00, or 0, followed by 1-14 digits
      return /^(\+?|00|0)[1-9]\d{1,14}$/.test(value);
    }, 'Ongeldig telefoonnummer');

  if (field.required) {
    return baseValidator.pipe(validator);
  }

  return z.preprocess((value) => (value === '' ? undefined : value), validator.optional());
}
